module.exports = __webpack_public_path__ + "img/5.846c5c99.jpg";